<template>
  <!-- 产品服务-车镇物流 -->
  <div class="box wl">
    <div v-if="!isM" class="wl0 bgimg"></div>
    <div v-if="isM" class="wlm0"></div>

    <div class="wl1">
      <div class="min_box">
        <h4 class="blue_h4">APP在线物流下单</h4>
        <p class="gary_dec">线上下单 结算，透明高效 操作简单</p>
        <div class="wl1_box">
          <ul class="wl1_ul">
            <li v-for="(item, index) in arr" :key="item.id">
              <img
                :src="picUrl + 'wl' + (index + 1) + '.png'"
                :alt="item.name"
              />
              <div>
                <p>{{ item.tit }}</p>
                <span>{{ item.dec }}</span>
                <span>{{ item.des }}</span>
              </div>
            </li>
          </ul>
          <img
            v-if="!isM"
            class="wlphobe"
            :src="picUrl + 'wlphone.png'"
            alt="车镇物流"
          />
          <img
            v-if="isM"
            class="wlphobe"
            :src="picUrl + 'wlm.png'"
            alt="车镇物流"
          />
        </div>
      </div>
    </div>

    <div class="wl2 bgimg">
      <div class="min_box">
        <img class="wlphobe2" :src="picUrl + 'wlphone2.png'" alt="车镇物流" />
        <div>
          <h4 class="blue_h4">可视化物流</h4>
          <p class="gary_dec">
            实时GPS定位，车辆在途信息 <br />
            全程追踪，运输路径全程掌控
          </p>
        </div>
      </div>
    </div>

    <div class="wl3">
      <div class="min_box">
        <div>
          <h4 class="blue_h4">物流网覆盖全国</h4>
          <p class="gary_dec">
            开放50多家物流平台，2万多条物流线路，<br />
            覆盖全国300+核心城市
          </p>
        </div>

        <img class="wlmap" :src="picUrl + 'wlmap.png'" alt="车镇物流" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Czwl",
  data() {
    return {
      picUrl: this.$root.picUrl,
      arr: [
        {
          tit: "在线订单",
          dec: "通过APP即可发起物流",
          des: "完成运输订单",
        },
        {
          tit: "寻价撮合",
          dec: "根据车型和数量在线智能报价",
          des: "全国承运商任意选",
        },
        {
          tit: "远程验车",
          dec: "APP在线验车系统",
          des: "全方位多角度检验",
        },
        {
          tit: "在途监控",
          dec: "全程可视化",
          des: "车辆当前位置精准定位",
        },
      ],
      isM: false,
    };
  },
  created() {
    this.isM = JSON.parse(sessionStorage.getItem("isM"));
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Proservices/czwl.vue